import styled from 'styled-components';
import background from '@Assets/images/backgrounds/backgroundLoginSvg.svg';

export const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1 0 auto;
	background-image: url(${background});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center center;
	height: 100%;
	width: 100%;
`;
export const Container = styled.div`
	border-radius: 0.25rem;
	box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
	/* max-width: 469px; */
	padding: 3.429rem 2.857rem;
	padding-top: 0px;

	@media (min-width: 2560px) {
		/* min-width: 600px; */
	}
`;
